import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { CheckCircle, Spinner, ArrowRight } from "@phosphor-icons/react";

export default function BillingSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [status, setStatus] = useState("pending"); // pending | paid | expired | error
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    if (attempts >= 6) { setStatus("expired"); return; }
    let cancelled = false;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (cancelled) return;
        if (data.payment_status === "paid") {
          setStatus("paid");
          await refresh();
          return;
        }
        if (data.status === "expired") { setStatus("expired"); return; }
        setTimeout(() => setAttempts((a) => a + 1), 2000);
      } catch {
        if (!cancelled) setStatus("error");
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId, attempts, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FFFFFF] p-6">
      <div className="card-flat p-10 max-w-md w-full text-center" data-testid="billing-success-card">
        {status === "pending" && (
          <>
            <Spinner size={44} className="text-[#7C8B6E] mx-auto animate-spin" />
            <h1 className="font-editorial text-3xl mt-6">Verifica pagamento...</h1>
            <p className="mt-2 text-[#6B6A65]">Un attimo solo.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle size={56} weight="fill" className="text-[#7C8B6E] mx-auto" />
            <h1 className="font-editorial text-4xl mt-6">Benvenuto in <span className="italic-accent text-[#7C8B6E]">Pro</span>.</h1>
            <p className="mt-4 text-[#6B6A65]">320 crediti smart al mese, Assistente illimitato, immobili senza limite, niente watermark. Iniziamo!</p>
            <button onClick={() => nav("/dashboard")} className="btn-primary mt-8 w-full justify-center" data-testid="go-to-dashboard">
              Vai al dashboard <ArrowRight size={16} weight="bold" />
            </button>
          </>
        )}
        {(status === "expired" || status === "error") && (
          <>
            <h1 className="font-editorial text-3xl text-[#7C8B6E]">Pagamento non confermato</h1>
            <p className="mt-4 text-[#6B6A65]">La sessione è scaduta o è avvenuto un errore. Riprova.</p>
            <button onClick={() => nav("/pricing")} className="btn-primary mt-8 w-full justify-center" data-testid="retry-pricing">
              Torna ai prezzi
            </button>
          </>
        )}
      </div>
    </div>
  );
}
